// костыль с цветами, пока не добавили во фронтон цвета услуг
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../media';

export const iconColor = css`
	max-width: 40px;
	max-height: 40px;

	& path:first-child {
		opacity: 0.2;
		fill: var(--service-primary);
	}

	& path:nth-child(2) {
		stroke: var(--service-primary);
		stroke-width: 1.25;
	}

	& path:nth-child(3) {
		fill: var(--service-primary);
	}
`;

export const BenefitsContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: auto;
	padding: 20px 32px;
	column-gap: 32px;
	background-color: var(--service-light);
	border-radius: 16px;
	${breakpoints.to.desktop} {
		flex-direction: column;
		row-gap: 16px;
		column-gap: 0;
	}
`;

export const BenefitItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: start;
	width: calc(100% / 3);
	column-gap: 16px;
	${breakpoints.to.desktop} {
		width: 100%;
	}
`;

export const titleStyles = css`
	display: block;
	margin: 0 0 4px;
`;
